export { DrillFooterSentenceGlyphsView } from "#drill-footer-sentence-glyphs-view";
